export const builtInStyle = `
  .ProseMirror::selection,
  .ProseMirror *::selection {
    color: inherit;
    text-decoration-color: inherit;
    background: rgba(24, 144, 255, 0.3);
  }

  .ProseMirror-hideselection *::selection { color: inherit; text-decoration-color: inherit; background: transparent; }
  .ProseMirror-hideselection { caret-color: transparent; }

  .exeditor-gapcursor {
    display: none;
    pointer-events: none;
    position: absolute;
  }

  .exeditor-gapcursor:after {
    content: "";
    display: block;
    position: absolute;
    top: -2px;
    width: 20px;
    border-top: 1px solid black;
    animation: exeditor-cursor-blink 1.1s steps(2, start) infinite;
  }

  @keyframes exeditor-cursor-blink {
    to {
      visibility: hidden;
    }
  }

  .ProseMirror-focused .exeditor-gapcursor {
    display: block;
  }

  img.ProseMirror-separator {
    display: inline !important;
    border: none !important;
    margin: 0 !important;
  }
`;
//# sourceMappingURL=style.js.map